import { Button, ButtonProps, useClipboard, useToast } from '@chakra-ui/react';
import { FC } from 'react';
import { Copy } from '../../assets';
import { useSocial } from '../../hooks';

export interface CopyLinkButtonProps extends ButtonProps {
  text?: string;
  url?: string;
  showLinkIcon?: boolean;
}

export const CopyButton: FC<CopyLinkButtonProps> = ({
  text,
  url,
  children: label,
  showLinkIcon = true,
  ...rest
}) => {
  const { handleSharingIsCaringInteraction } = useSocial();
  const { onCopy } = useClipboard(url || text || '');
  const toast = useToast();

  const handleCopyLink = () => {
    const pg = url ? new URL(url).searchParams.get('pg') : '';
    if (pg?.toLowerCase() === 'personal') {
      // This is a personal share
      handleSharingIsCaringInteraction();
    }
    onCopy();
    toast({
      title: 'Copied.',
      status: 'success',
      duration: 2000,
    });
  };

  return (
    <Button
      leftIcon={showLinkIcon ? <Copy boxSize="24px" /> : undefined}
      onClick={handleCopyLink}
      {...rest}
    >
      {typeof label === 'string' && label}
    </Button>
  );
};
